import moment from 'moment';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';
import { getIcs2RowClassName } from 'store/declarations/eu/ics2/ics2-declaration-list';

const getDeclarationTableRowClassName = (record: any, expandedRowKeys: readonly React.Key[] = []) => {
    const declarationStatus = record?.status ?? record?.declaration?.status;
    const documentsUploadRequested =
        record?.irelandImportDeclaration?.documentsUploadRequested ??
        record?.irelandH7ImportDeclaration?.documentsUploadRequested ??
        record?.cdsDeclaration?.documentsUploadRequested ??
        record?.actionRequired ??
        record?.inspectionRequired;

    const gmrExpiryDays =
        moment(record?.gvmsDeclaration?.gmrExpiredAt).startOf('day').diff(moment().startOf('day'), 'days') + 1;

    let className = 'declaration-table-row';
    if (
        declarationStatus === DeclarationStatuses.REJECTED ||
        declarationStatus === DeclarationStatuses.INVALID ||
        record?.doNotLoadReceived ||
        gmrExpiryDays < 0
    ) {
        className += ' declaration-table-row-red';
    } else if (documentsUploadRequested) {
        className += ' declaration-table-row-orange';
    } else if (record?.gvmsDeclaration?.gmrExpiredAt && gmrExpiryDays <= 7 && gmrExpiryDays >= 0) {
        className += ' declaration-table-row-yellow';
    }

    const ics2ClassName = getIcs2RowClassName(record, expandedRowKeys);
    if (ics2ClassName) className += ` ${ics2ClassName}`;

    return className;
};

export default getDeclarationTableRowClassName;
